import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetPaymentMethodList = () => {
    const send = useGenericSend();

    return useCallback(async (options: Types.IGetPaymentMethodListRequest): Promise<Types.IPaymentMethodListItem[]> => {
        const { data } = await send<Types.IGetPaymentMethodListRequest, Types.IGetPaymentMethodListResponse>({
            ID: 33001,
            responses: [33002, 33003],
            description: 'Get payment method list',
            limits: true,
            cancreatenewaccount: true,
            returnaccountfields: true,
            ...options
        });

        return data?.payments?.method;
    }, [send]);
};
